import executeRequest from "../../../../../../../../../server/public/modules/request.js";
export class Uploader {
    static async useRetries(callback) {
        for (let i = 0; i < 3; i++) {
            const result = await callback();
            if (result)
                return true;
        }
        return false;
    }
    static async useResultRetries(callback) {
        for (let i = 0; i < 3; i++) {
            const result = await callback();
            if (result)
                return result;
        }
        return false;
    }
    static async upload(data, url = "/api/public/merchants/shop/group/uploadFiles") {
        try {
            const signal = AbortSignal.timeout(30000);
            const response = await fetch(url, {
                method: "POST",
                body: data,
                signal,
            });
            const result = await response.json();
            if (result.status == 200) {
                return true;
            }
        }
        catch (err) {
            return false;
        }
        return false;
    }
    static async uploadByUrl(data, gallery, group, imageName, type = "fullsize") {
        const url = `/api/public/merchants/gallery/${gallery}/${group}/${type}/${imageName}`;
        const { status, url: uploadUrl } = await executeRequest(url, "GET");
        if (status !== 200)
            return false;
        const response = await fetch(uploadUrl, {
            method: "PUT",
            body: data,
            redirect: "follow",
            headers: {
                "Content-Type": "image/jpeg",
            },
        });
        try {
            const result = await response.json();
            if (result.status === 200)
                return true;
        }
        catch (err) {
            console.warn(err);
        }
        return false;
    }
}
